import * as React from "react";
import { Helmet } from "react-helmet";
import { graphql, useStaticQuery } from "gatsby"

import SiteLogo from "../../../../static/images/start-logo-social.jpg";

import useSiteSettings from "../../../hooks/useSiteSettings";
import slugRewrite from "../../internal/slugRewrite/slugRewrite";

const Seo = ({ blok, locale, location, data}) => {
  const siteSettings = useSiteSettings(locale);
  /* Used when we add cononical url to per page */
  // const canonical = blok ? blok.canonical_url: "";
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            siteUrl
          }
        }
      }
    `
  )
  const baseurl = site.siteMetadata.siteUrl;
  const host = location.host;
  const pageUrl = slugRewrite(baseurl, blok.full_slug, locale)
  const blokSeo = getPageSeo(blok, SiteLogo, baseurl);
  let canonicals = [];
  if (blok.slug && siteSettings.language_selector) {
    canonicals.push({ rel: "canonical", href: slugRewrite(baseurl, blok.full_slug, locale)});
    // canonicals.push({ rel: "canonical", href: baseurl + "/" + blok.slug });
    siteSettings.language_selector.map((language) => {
      canonicals.push({
        rel: "alternate",
        hrefLang: language,
        href: slugRewrite(baseurl, blok.full_slug, language)
        // href: baseurl + "/" + language + "/" + blok.slug,
      });
    });
  }

  if(blok && blok.content && blok.content.component === "story" && blok.content.is_japanese) {
    // Change language for japanese stories
    locale = "ja"
  }

  return (
    <Helmet>
      <html lang={locale} />
      {blokSeo.title ? <title>{blokSeo.title}</title> : null}
      {pageUrl ? (
        <meta property="og:url" content={pageUrl} />
      ) : null}
      {blokSeo.description ? (
        <meta name="description" content={blokSeo.description} />
      ) : null}
      {blokSeo.description ? (
        <meta property="description" content={blokSeo.description} />
      ) : null}
      {blokSeo.og_image ? (
        <meta name="og:image" content={blokSeo.og_image} />
      ) : null}
      {blokSeo.og_image ? (
        <meta property="og:image" content={blokSeo.og_image} />
      ) : null}
      {blokSeo.og_title ? (
        <meta name="og:title" content={blokSeo.og_title} />
      ) : null}
      {blokSeo.og_title ? (
        <meta property="og:title" content={blokSeo.og_title} />
      ) : null}
      {blokSeo.og_title ? (
        <meta property="og:site_name" content={host} />
      ) : null}
      {blokSeo.og_description ? (
        <meta name="og:description" content={blokSeo.og_description} />
      ) : null}
      {blokSeo.og_description ? (
        <meta property="og:description" content={blokSeo.og_description} />
      ) : null}
      {blokSeo.twitter_image ? (
        <meta name="twitter:image" content={blokSeo.twitter_image} />
      ) : null}
      {blokSeo.twitter_title ? (
        <meta name="twitter:title" content={blokSeo.twitter_title} />
      ) : null}
      {blokSeo.twitter_description ? (
        <meta
          name="twitter:description"
          content={blokSeo.twitter_description}
        />
      ) : null}
      {blokSeo.twitter_title ? (
        <meta
          name="twitter:card"
          content="summary"
        />
      ) : null}
      {canonicals
        ? canonicals.map((props) => {
          return props.hrefLang ? (
            <link
              rel={props.rel}
              hrefLang={props.hrefLang}
              href={props.href}
              key={props.href}
            />
          ) : (
            <link rel={props.rel} href={props.href} key={props.href} />
          );
        })
        : null}
    </Helmet>
  );
};

export default Seo;

function getPageSeo(blok, siteLogo, baseurl) {
  var blokSeo = {};
  if (blok) {
    if (blok.field_component == "page" ) {
      var blokContentSeo = blok.content.seo ? blok.content.seo : {};
      blokSeo = {
        title: blokContentSeo.title && blokContentSeo.title !== "" ? blokContentSeo.title : blok.name,
        description: blokContentSeo.description
          ? blokContentSeo.description
          : null,
        og_image: blokContentSeo.og_image
          ? blokContentSeo.og_image
          : baseurl + siteLogo,
        og_title: blokContentSeo.og_title
          ? blokContentSeo.og_title
          : blokContentSeo.title && blokContentSeo.title !== ""
            ? blokContentSeo.title
            : blok.name,
        og_description: blokContentSeo.og_description
          ? blokContentSeo.og_description
          : blokContentSeo.description ? blokContentSeo.description : null,
        twitter_image: blokContentSeo.twitter_image
          ? blokContentSeo.twitter_image
          : baseurl + siteLogo,
        twitter_title: blokContentSeo.twitter_title && blokContentSeo.twitter_title !== ""
          ? blokContentSeo.twitter_title
          : blokContentSeo.title && blokContentSeo.title !== ""
            ? blokContentSeo.title
            : blok.name,
        twitter_description: blokContentSeo.twitter_description
          ? blokContentSeo.twitter_description
          : blokContentSeo.description ? blokContentSeo.description : null, 
      };
      return blokSeo;
    } else if (blok.pageType && blok.pageType == "404") {
      return blok;
    } else {
      var blokContentSeo = blok.content.seo ? blok.content.seo : {};
      const blokContentImage = blok && blok.content && blok.content.image && blok.content.image.filename ? blok.content.image.filename : "";
      blokSeo = {
        title:  blokContentSeo.title && blokContentSeo.title !== "" ? blokContentSeo.title : blok.content.headline !== "" ? blok.content.headline : blok.name,
        description: blokContentSeo.description
          ? blokContentSeo.description
          : blok.content.excerpt,
        og_image: blokContentSeo.og_image
          ? blokContentSeo.og_image
          : blokContentImage
            ? blokContentImage
            : baseurl + siteLogo,
        og_title: blokContentSeo.og_title && blokContentSeo.og_title !== ""
          ? blokContentSeo.og_title
          : blok.content.headline && blok.content.headline !== "" ? blok.content.headline : blok.name,
        og_description: blokContentSeo.og_description
          ? blokContentSeo.og_description
          : blokContentSeo.description ? blokContentSeo.description : blok.content.excerpt ? blok.content.excerpt : null,
        twitter_image: blokContentSeo.twitter_image
          ? blokContentSeo.twitter_image
          : blokContentImage
            ? blokContentImage
            : baseurl + siteLogo,
        twitter_title: blokContentSeo.twitter_title && blokContentSeo.twitter_title !== ""
          ? blokContentSeo.twitter_title
          : blok.content.headline && blok.content.headline !== "" ? blok.content.headline : blok.name,
        twitter_description: blokContentSeo.twitter_description
          ? blokContentSeo.twitter_description
          : blok.content.excerpt ? blok.content.excerpt : null,
      };
      return blokSeo;
    }
  }
}
